const INDEX_TABLE = [
  { points: 2, index: 36 },
  { points: 4, index: 35 },
  { points: 5, index: 34 },
  { points: 7, index: 33 },
  { points: 8, index: 32 },
  { points: 10, index: 31 },
  { points: 11, index: 30 },
  { points: 12, index: 29 },
  { points: 14, index: 28 },
  { points: 16, index: 27 },
  { points: 17, index: 26 },
  { points: 19, index: 25 },
  { points: 20, index: 24 },
  { points: 22, index: 23 },
  { points: 24, index: 22 },
  { points: 26, index: 21 },
  { points: 27, index: 20 },
  { points: 28, index: 19 },
  { points: 31, index: 18 },
  { points: 32, index: 17 },
  { points: 34, index: 16 },
  { points: 36, index: 15 },
  { points: 38, index: 14 },
  { points: 41, index: 13 },
  { points: 42, index: 12 },
  { points: 45, index: 11 },
  { points: 48, index: 10 },
  { points: 50, index: 9 },
  { points: 51, index: 8 },
  { points: 54, index: 7 },
  { points: 57, index: 6 },
  { points: 60, index: 5 },
  { points: 62, index: 4 },
  { points: 64, index: 3 },
  { points: 70, index: 2 },
  { points: 72, index: 1 },
  { points: 76, index: 0 },
  { points: 81, index: -1 },
  { points: 85, index: -2 },
  { points: 90, index: -3 },
  { points: 95, index: -4 },
  { points: 100, index: -5 },
  { points: 105, index: -6 },
  { points: 110, index: -7 },
];

export const calculateGlobalIndex = (totalPoints: number): number => {
  // If points are less than the minimum in the table
  if (totalPoints < INDEX_TABLE[0].points) {
    return INDEX_TABLE[0].index;
  }

  // If points are more than the maximum in the table
  if (totalPoints > INDEX_TABLE[INDEX_TABLE.length - 1].points) {
    return INDEX_TABLE[INDEX_TABLE.length - 1].index;
  }

  // Find the closest match in the table
  for (let i = 0; i < INDEX_TABLE.length; i++) {
    if (totalPoints === INDEX_TABLE[i].points) {
      return INDEX_TABLE[i].index;
    }
    
    if (totalPoints < INDEX_TABLE[i].points) {
      // If this is the first entry, return its index
      if (i === 0) return INDEX_TABLE[0].index;
      
      // Otherwise, return the index of the previous entry
      return INDEX_TABLE[i - 1].index;
    }
  }

  // If we get here, return the last index in the table
  return INDEX_TABLE[INDEX_TABLE.length - 1].index;
};
